import { DialogComponent, DialogOpenEvent } from '@theme/dialog';

/**
 * A custom element that manages a product content drawer.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog - The dialog element.
 *
 * @extends {DialogComponent}
 */
class ProductContentDrawerComponent extends DialogComponent {
  /** @type {number} */
  #summaryThreshold = 0.5;

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
  }

  open() {
    this.showDialog();

    const header = document.querySelector('header');
    if(header) {
      header.style.position = 'fixed';
      header.style.width = '100%';
    }
  }

  close() {
    this.closeDialog();
  }

  #updateStickyState() {
    const { dialog } = /** @type {Refs} */ (this.refs);
    if (!dialog) return;

    // Refs do not cross nested `*-component` boundaries (e.g., `cart-items-component`), so we query within the dialog.
    const content = dialog.querySelector('.product-content-drawer__content');

    if (!content) {
      // Ensure the dialog doesn't get stuck in "unsticky" mode when summary disappears (e.g., empty cart).
      dialog.setAttribute('product-content-drawer-sticky', 'false');
      return;
    }

    const drawerHeight = dialog.getBoundingClientRect().height;
    dialog.setAttribute('product-content-drawer-sticky', drawerHeight > this.#summaryThreshold ? 'false' : 'true');
  }
}

if (!customElements.get('product-content-drawer')) {
  customElements.define('product-content-drawer', ProductContentDrawerComponent);
}
